import {
  getAttendBrokenLine,
  getAttendBrokenLineForTeacher,
  getAttendClassListByPage,
  getAttendTeacherListByPage,
  getAttendFeatureImgList,
  getAttendStudentListByPage,
  getTimeSlotBrokenLine
} from '@/api/attendance';
import util from '@/libs/util.js';

const attendance = {
  namespaced: true,
  state: {
    /* 获取考勤数据loading */
    attendanceDataLoading: false,
    attendanceNumList: {},
    tableData: [],
    tableTotal: 0,
    studentTableData: [],
    lineChartData: [],
    lineChartDataForClass: [],
    pieChartData: [],
    barChartData: [],
    peopleData: {}, // 人员数据和头像，用于班级详情页展示
    titleSelectBak: {}
  },
  mutations: {
    SET_ATTENDANCE_DATA_LOADING: (state, attendanceDataLoading) => {
      let timeout = 0;
      if (!attendanceDataLoading) {
        timeout = 1000;
      }
      setTimeout(() => {
        state.attendanceDataLoading = attendanceDataLoading;
      }, timeout);
    },
    SET_ATTENDANCE_NUM_LITS: (state, attendanceNumList) => {
      state.attendanceNumList = attendanceNumList;
    },
    SET_TABLE_DATA: (state, tableData) => {
      state.tableData = tableData;
    },
    SET_TABEL_TOTAL: (state, count) => {
      state.tableTotal = count;
    },
    SET_LINE_CHART_DATA: (state, lineChartData) => {
      state.lineChartData = lineChartData;
      state.lineChartDataForClass = lineChartData;
    },
    SET_TITLE_SELECT_BAK: (state, titleSelectBak) => {
      state.titleSelectBak = titleSelectBak;
    },
    SET_PIE_CHART_DATA: (state, pieChartData) => {
      state.pieChartData = pieChartData;
    },
    SET_BAR_CHART_DATA: (state, barChartData) => {
      state.barChartData = barChartData;
    },
    SET_PEOPLE_DATA: (state, peopleData) => {
      state.peopleData = peopleData;
    },
    SET_STUDENT_TABLEA_DATA: (state, studentTableData) => {
      state.studentTableData = studentTableData;
    }
  },
  actions: {
    resetData({ commit }) {
      commit('SET_TABLE_DATA', []);
      commit('SET_TABEL_TOTAL', 0);
      commit('SET_LINE_CHART_DATA', {});
    },
    setTitleSelectBak(_, titleSelectBak) {
      util.cookies.set('titleSelectBak', JSON.stringify(titleSelectBak));
    },
    changeAttendanceDataLoading({ commit }, attendanceDataLoading) {
      commit('SET_ATTENDANCE_DATA_LOADING', attendanceDataLoading);
    },
    getAttendanceNum({ commit }, requestParams) {
      this.dispatch('ai/attendance/changeAttendanceDataLoading', true);
      if (requestParams.type === 'student') {
        const params = {
          classId: requestParams.classId,
          schoolId: requestParams.schoolId,
          startDate: requestParams.startDate,
          endDate: requestParams.endDate,
          weekFlag: requestParams.weekFlag,
          planId: requestParams.planId,
          schedulesId: requestParams.schedulesId
        };
        getAttendBrokenLine(params).then(res => {
          const numObj = {
            zhengchang: {
              name: '正常',
              num: 0,
              per: 0
            },
            chidao: {
              name: '迟到',
              num: 0,
              per: 0
            },
            queqin: {
              name: '缺勤',
              num: 0,
              per: 0
            }
          };
          if (res && res.length > 0 && res[0]) {
            const element = res[0];
            numObj.zhengchang.num = element.ontimeCount;
            numObj.zhengchang.per = `${((element.ontimeCount / element.totalCount) * 100).toFixed(
              1
            )}%`;
            numObj.chidao.num = element.lateCount;
            numObj.chidao.per = `${((element.lateCount / element.totalCount) * 100).toFixed(1)}%`;
            numObj.queqin.num = element.absentCount;
            numObj.queqin.per = `${((element.absentCount / element.totalCount) * 100).toFixed(1)}%`;
          }
          commit('SET_ATTENDANCE_NUM_LITS', numObj);
          this.dispatch('ai/attendance/changeAttendanceDataLoading', false);
        });
      } else {
        const params = {
          schoolId: requestParams.schoolId,
          startDate: requestParams.startDate,
          endDate: requestParams.endDate,
          weekFlag: requestParams.weekFlag
        };
        getAttendBrokenLineForTeacher(params).then(res => {
          const numObj = {
            zhengchang: {
              name: '正常',
              num: 0,
              per: 0
            },
            chidao: {
              name: '迟到',
              num: 0,
              per: 0
            },
            queqin: {
              name: '缺勤',
              num: 0,
              per: 0
            }
          };
          if (res && res.length > 0 && res[0]) {
            const element = res[0];
            numObj.zhengchang.num = element.ontimeCount;
            numObj.zhengchang.per = `${((element.ontimeCount / element.totalCount) * 100).toFixed(
              1
            )}%`;
            numObj.chidao.num = element.lateCount;
            numObj.chidao.per = `${((element.lateCount / element.totalCount) * 100).toFixed(1)}%`;
            numObj.queqin.num = element.absentCount;
            numObj.queqin.per = `${((element.absentCount / element.totalCount) * 100).toFixed(1)}%`;
          }
          commit('SET_ATTENDANCE_NUM_LITS', numObj);
          this.dispatch('ai/attendance/changeAttendanceDataLoading', false);
        });
      }
    },
    getStudentTbaleData({ commit }, requestParams) {
      this.dispatch('ai/attendance/changeAttendanceDataLoading', true);
      getAttendStudentListByPage(requestParams).then(res => {
        if (res) {
          commit('SET_STUDENT_TABLEA_DATA', res.list);
          commit('SET_TABEL_TOTAL', res.dataCount);
        }
        this.dispatch('ai/attendance/changeAttendanceDataLoading', false);
      });
    },
    getTableData({ commit }, requestParams) {
      if (requestParams.type === 'student') {
        const parmas = {
          schoolId: requestParams.schoolId,
          startDate: requestParams.startDate,
          endDate: requestParams.endDate,
          weekFlag: requestParams.weekFlag,
          page: requestParams.page,
          pageSize: requestParams.pageSize,
          planId: requestParams.planId,
          schedulesId: requestParams.schedulesId,
          order: requestParams.order,
          classIds: requestParams.classIds
        };
        commit('SET_TABLE_DATA', []);
        commit('SET_TABEL_TOTAL', 0);
        this.dispatch('ai/attendance/changeAttendanceDataLoading', true);
        getAttendClassListByPage(parmas).then(res => {
          if (res && res.list.length > 0) {
            commit('SET_TABLE_DATA', res.list);
            commit('SET_TABEL_TOTAL', res.dataCount);
          } else {
            commit('SET_TABLE_DATA', []);
            commit('SET_TABEL_TOTAL', 0);
          }
          this.dispatch('ai/attendance/changeAttendanceDataLoading', false);
        });
      } else {
        const parmas = {
          schoolId: requestParams.schoolId,
          startDate: requestParams.startDate,
          endDate: requestParams.endDate,
          weekFlag: requestParams.weekFlag,
          teacherIds: requestParams.teacherIds,
          page: requestParams.page,
          pageSize: requestParams.pageSize,
          order: requestParams.order
        };
        getAttendTeacherListByPage(parmas).then(res => {
          if (res && res.list.length > 0) {
            commit('SET_TABLE_DATA', res.list);
            commit('SET_TABEL_TOTAL', res.dataCount);
          } else {
            commit('SET_TABLE_DATA', []);
            commit('SET_TABEL_TOTAL', 0);
          }
        });
      }
    },
    getLineData({ commit }, requestParams) {
      if (requestParams.type === 'student') {
        const params = {
          classId: requestParams.classId,
          schoolId: requestParams.schoolId,
          startDate: requestParams.startDate,
          endDate: requestParams.endDate,
          weekFlag: requestParams.weekFlag,
          planId: requestParams.planId,
          schedulesId: requestParams.schedulesId
        };
        getAttendBrokenLine(params).then(res => {
          if (res && res.length > 0 && res[0]) {
            commit('SET_LINE_CHART_DATA', res);
          } else {
            commit('SET_LINE_CHART_DATA', []);
          }
        });
      } else {
        const params = {
          schoolId: requestParams.schoolId,
          startDate: requestParams.startDate,
          endDate: requestParams.endDate,
          weekFlag: requestParams.weekFlag
        };
        getAttendBrokenLineForTeacher(params).then(res => {
          if (res && res.length > 0 && res[0]) {
            commit('SET_LINE_CHART_DATA', res);
          } else {
            commit('SET_LINE_CHART_DATA', []);
          }
        });
      }
    },
    getPieData({ commit }, requestParams) {
      const params = {
        classId: requestParams.classId,
        schoolId: requestParams.schoolId,
        startDate: requestParams.startDate,
        endDate: requestParams.endDate,
        weekFlag: requestParams.weekFlag,
        planId: requestParams.planId,
        schedulesId: requestParams.schedulesId
      };
      getAttendBrokenLine(params).then(res => {
        let data = [];
        if (res && res.length > 0 && res[0]) {
          data = [
            {
              name: `未签到\n${res[0].absentCount} 人`,
              value: res[0].absentCount
            },
            {
              name: `迟到\n${res[0].lateCount} 人`,
              value: res[0].lateCount
            },
            {
              name: `按时签到\n${res[0].ontimeCount} 人`,
              value: res[0].ontimeCount
            }
          ];
        }
        commit('SET_PIE_CHART_DATA', data);
      });
    },
    getBarData({ commit }, requestParams) {
      getTimeSlotBrokenLine(requestParams).then(res => {
        console.log('res', res);
        const data = [];
        if (res.length > 0) {
          for (let i = 0; i < res.length; i++) {
            const element = res[i];
            data.push({
              name: element.stage,
              value: element.clockNum
            });
          }
          commit('SET_BAR_CHART_DATA', data);
        }
      });
    },
    getPeopleData({ commit }, requestParams) {
      // const params = {
      //   schoolId: requestParams.schoolId,
      //   startDate: '2022-03-12',
      //   endData: '2022-03-12',
      //   planId: '1',
      //   schedulesId: '1',
      //   classId: requestParams.classId
      // };
      commit('SET_PEOPLE_DATA', {});
      getAttendFeatureImgList(requestParams).then(res => {
        const data = {
          absentCount: res.absentData.length,
          absentStudents: res.absentData,
          lateCount: res.lateData.length,
          lateStudents: res.lateData
        };
        console.log('data', data);
        commit('SET_PEOPLE_DATA', data);
      });
    }
  }
};

export default attendance;
